<template>
  <a
    :href="homepageUrl"
    :class="['nav-logo', `nav-logo--${variant}`, `nav-logo--${theme}`]"
    v-on="$listeners"
    @click="trackLogoClick"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      version="1.1"
      y="0px"
      x="0px"
      viewBox="-0.75 -0.98 496 497"
      enable-background="new -0.75 -0.98 496 497"
    >
      <path
        d="m331.56 116.08c-0.457 0.458-0.917 1.031-1.374 1.489l-19.023 19.023c-0.229 0.229-0.344 0.344-0.46 0.458-0.457 0.573-0.457 1.146 0.116 1.948 4.813 8.136 7.792 16.845 8.825 26.128 2.062 19.022-2.753 36.097-14.669 51.109-10.199 12.834-23.492 20.856-39.422 24.409-7.334 1.605-14.782 1.718-22.231 0.917-12.262-1.262-23.264-5.73-33.119-13.064-14.21-10.542-23.034-24.523-26.701-41.942-1.375-6.418-1.604-12.949-1.031-19.366 1.375-15.012 7.105-28.306 17.304-39.65 9.741-10.887 21.659-17.992 35.754-21.2 6.991-1.605 13.98-2.178 21.201-1.491 10.313 0.917 19.939 3.897 28.877 9.053 1.146 0.688 1.604 0.229 2.293-0.458 6.303-6.304 12.604-12.606 18.908-18.909 0.458-0.458 0.917-1.032 1.489-1.719 7.78 7.788 15.45 15.468 23.25 23.258m-42.98 58.44c0.573-22.117-16.846-38.16-36.442-38.733-22.116-0.574-38.618 17.762-38.618 37.587 0 20.283 17.075 37.817 37.586 37.473 20.17 0.23 37.01-16.39 37.47-36.33"
      ></path>
      <path
        d="m317.58 327.62c0.114 18.564 0 37.242 0 55.808v2.521h-33.232v-2.291c0-19.482 0.114-38.964 0-58.444 0-10.199-3.553-19.138-11.001-26.243-4.928-4.698-10.887-7.448-17.762-8.365-8.939-1.261-17.076 0.917-24.294 6.303-7.22 5.501-11.46 12.95-12.835 21.772-0.687 4.241-0.802 8.597-0.802 12.95-0.114 17.305 0 34.493 0 51.797v2.406h-33.003v-2.176c0-20.973-0.23-42.058 0.114-63.029 0.229-11.114 3.782-21.658 9.626-31.284 9.74-16.043 23.606-26.356 41.827-30.597 5.615-1.261 11.688-1.833 17.533-1.604 18.221 0.802 33.805 8.021 46.182 21.658 8.824 9.854 14.439 21.313 16.387 34.493 0.79 4.8 1.25 9.61 1.25 14.31"
      ></path>
    </svg>
  </a>
</template>

<script>
import {
  notifyExternalServices,
  ACTIONS,
} from '@/assets/javascripts/on/external-services/external-services'

export const VARIANTS = {
  desktop: 'desktop',
  mobile: 'mobile',
}

export const THEMES = {
  transitioning: 'transitioning',
  black: 'black',
  white: 'white',
}

export default {
  name: 'NavLogo',

  props: {
    homepageUrl: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: VARIANTS.desktop,
      validator(value) {
        return Object.values(VARIANTS).includes(value)
      },
    },
    theme: {
      type: String,
      default: THEMES.transitioning,
      validator(value) {
        return Object.values(THEMES).includes(value)
      },
    },
  },

  methods: {
    trackLogoClick() {
      notifyExternalServices({
        action: ACTIONS.navigation,
        details: { action: 'main_navigation', label: 'logo' },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-logo {
  svg {
    display: block;

    path {
      transition: fill $transition-time ease-in-out;
    }
  }

  &--mobile {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    svg {
      width: $header-height;
      height: $header-height;
    }
  }

  &--desktop {
    position: initial;
    left: initial;
    transform: none;
    height: 69px;

    svg {
      width: $header-height-large;
      height: $header-height-large;
    }
  }

  &--black {
    svg {
      path {
        fill: $color-black;
      }
    }
  }

  &--white {
    svg {
      path {
        fill: $color-white;
      }
    }
  }

  &--transitioning {
    svg {
      background: $color-black;
      transition: fill $transition-time ease-in-out, background $transition-time ease-in-out;

      path {
        fill: $color-white;
      }

      &:hover {
        background: #f8f8f8;

        path {
          fill: $color-grey-dark-2;
        }
      }
    }
  }
}
</style>
